import { GET, PATCH, POST } from "../../../helper/xbi4RestFunctions";
export const getOrgUserPersonalFaqByOrgUserId = async (
  org_id: any,
  org_user_id: any
) => {
  const path = `/orgs/${org_id}/users/${org_user_id}/read_personal_queries`;
  return await GET(path)
    .then((result) => {
      return result[1];
    })
    .catch((err) => {
      console.log("error on fetching objective >", err);
      return err;
    });
};
